export default [
    {
        url: "/dashboard",
        name: "Dashboard",
        slug: "dashboard",
        icon: "GridIcon",
    },
    {
        url: "/clientes",
        name: "Clientes",
        slug: "clientes",
        icon: "LayersIcon",
    },
    {
        url: null,
        name: "Relatórios",
        slug: "dashboard",
        icon: "TrendingUpIcon",
        submenu: [
            {
                url: "/comissoes",
                name: "Comissões",
                slug: "comissoes",
                icon: "DollarSignIcon",
            },
            {
                url: "/tickets",
                name: "Tickets",
                slug: "tickets",
                icon: "LifeBuoyIcon",
            },
            {
                url: "/vendas",
                name: "Vendas",
                slug: "vendas",
                icon: "ShoppingBagIcon",
            }
        ]
    },
]
